/* eslint-disable prettier/prettier */
import React from 'react'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { showToast } from './toastSlice'
import makeRequest from 'src/services/api'
import handleGeneralError from '../helpers/errorHandler'
import { fetchRolesUrl, fetchFeaturesUrl, createRoleUrl, editRolesUrl, } from 'src/services/urls'

const initialState = {
  loading: false,
  roles: [],
  features: [],
  error: '',
}

// Fetch all roles and features available for portal
export const fetchRolesAndFeatures = createAsyncThunk('rolesAndAccess/fetchRolesAndFeatures', async (options, { dispatch }) => {
  try {

    const rolesRes = await makeRequest(fetchRolesUrl())
    const featuresRes = await makeRequest(fetchFeaturesUrl())

    const featuresWithRoles = featuresRes.data.data.docs.map((item) => {
      return { ...item, roles: [...rolesRes?.data?.data?.docs] }
    })
    const removeAllAdminNone = featuresWithRoles.filter((item, i) => (item.name !== 'Admin' && item.name !== 'None' && item.name !== 'All'))
    return { roles: rolesRes?.data?.data?.docs, features: removeAllAdminNone, }

  } catch (e) {
    handleGeneralError(e, { dispatch, showToast })
  }
})

// Add/Create new role
export const addRole = createAsyncThunk('rolesAndAccess/addRole', async (data, { dispatch }) => {
  try {
    let body = {
      createdBy: data.createdBy,
      name: data.name,
      status: data.status,
      permissions: data.permissions
    }
    const response = await makeRequest(createRoleUrl(), 'POST', body)

    const { displayMessage, status } = response.data
    if (response.data.statusCode === 200) {
      dispatch(showToast({ title: status, message: displayMessage, color: 'success' }))
    }
    dispatch(fetchRolesAndFeatures())
    return response.data

  } catch (e) {
    handleGeneralError(e, { dispatch, showToast })
  }
})

// Edit/Update or enable/disable a feature for a particular role
export const editRoles = createAsyncThunk('rolesAndAccess/editRoles', async (data, { dispatch }) => {
  try {
    let body = {
      updatedBy: data.updatedBy,
      permissions: data.permissions
    }
    const roleId = data.roleId
    const response = await makeRequest(editRolesUrl(roleId), 'PUT', body)

    const { displayMessage, status } = response.data
    if (response.data.statusCode === 200) {
      dispatch(showToast({ title: status, message: displayMessage, color: 'success' }))
    }
    dispatch(fetchRolesAndFeatures())
    return response.data

  } catch (e) {
    handleGeneralError(e, { dispatch, showToast })
  }
})

// Delete a role
export const deleteRoles = createAsyncThunk('rolesAndAccess/deleteRoles', async (data, { dispatch }) => {
  try {
    const roleId = data.roleId

    const response = await makeRequest(editRolesUrl(roleId), 'DELETE', {})

    const { displayMessage, status } = response.data
    if (response.data.statusCode === 200) {
      dispatch(showToast({ title: status, message: displayMessage, color: 'success' }))
    }
    dispatch(fetchRolesAndFeatures())
    return response.data

  } catch (e) {
    handleGeneralError(e, { dispatch, showToast })
  }
})

const rolesAndAccessSlice = createSlice({
  name: 'rolesAndAccess',
  initialState,
  reducers: {
    setActivePage: (state, action) => {
      state.activePage = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchRolesAndFeatures.pending, (state) => {
      state.loading = true
    })
    builder.addCase(fetchRolesAndFeatures.fulfilled, (state, action) => {
      state.loading = false
      state.roles = action.payload?.roles
      state.features = action.payload?.features
      state.error = ''
    })
    builder.addCase(fetchRolesAndFeatures.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
    builder.addCase(addRole.fulfilled, (state, action) => {
      state.loading = false
      state.error = ''
    })
    builder.addCase(addRole.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
    builder.addCase(editRoles.fulfilled, (state, action) => {
      state.loading = false
      state.error = ''
    })
    builder.addCase(editRoles.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
    builder.addCase(deleteRoles.fulfilled, (state, action) => {
      // state.activePage = 0
      state.loading = false
      state.error = ''
    })
    builder.addCase(deleteRoles.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })

  },
})

export default rolesAndAccessSlice.reducer
